import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import * as yup from "yup";
import API from "../../../api/api";
import { useToast } from "../../../contexts/toast";
import { parsedUser } from "../../../utils/GetCurrentUser";
import yupTypeValidator from "../../../utils/YupTypeValidator";
import FieldSelector from "../../customComponents/FieldSelector";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { useTranslation } from "react-i18next";

const ApplyCharge = (props) => {
  const user = parsedUser();
  const { t } = useTranslation();
  const [records, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const toast = useToast();
  const [generalError, setGeneralError] = useState(null);
  const [billingServices, setBillingServices] = useState([]);
  const [validationsSchema, setValidationSchema] = useState(null);
  const [fields, setFields] = useState([
    {
      FieldName: "IdBillingService",
      FieldType: "varchar",
      FieldTitle: "Billing Service",

      cssClasss: "col-12 ",
      HtmlType: "select",
      PlaceHolder: "",
      DefaultValue: "",
      OptionValues: "",
      DataSource:
        '{"HashID":"7f51e02cd7a8b31f2cc5eea5c1775fec4013da549ccb46dae33c226e76872c32"}',
      Required: true,
      Visible: true,
      ReadOnly: false,
      GroupBy: 0,
    },
    {
      FieldName: "Details",
      FieldType: "varchar",
      FieldTitle: "Details",

      cssClasss: "col-12 ",
      HtmlType: "textarea",
      PlaceHolder: "",
      DefaultValue: "",
      OptionValues: "",
      //	"DataSource": '{"HashID":"2b868d0982957ef9246670e793308c8cc04ad373d1355554308e6e2e189ab505"}',
      Required: true,
      Visible: true,
      ReadOnly: false,
      GroupBy: 0,
    },
    {
      FieldName: "DetailReferences",
      FieldType: "varchar",
      FieldTitle: "Reference",

      cssClasss: "col-12 ",
      HtmlType: "text",
      PlaceHolder: "",
      DefaultValue: "",
      OptionValues: "",
      //	"DataSource": '{"HashID":"2b868d0982957ef9246670e793308c8cc04ad373d1355554308e6e2e189ab505"}',
      Required: true,
      Visible: true,
      ReadOnly: false,
      GroupBy: 0,
    },
    {
      IdAppForm: 64,
      Id: 6400010,
      FieldName: "IdCurrency",
      FieldType: "int",
      FieldTitle: t("Currency"),
      Position: 3,
      cssClasss: "col-md-12",
      HtmlType: "select",
      PlaceHolder: "",
      DefaultValue: null,
      OptionValues: null,
      DataSource:
        '{"HashID":"637f44b9bafa1fe74b0a72c887b1c3262c833080fea07d40768858638f0fc87b"}',
      Required: false,
      Visible: true,
      ReadOnly: false,
    },
    {
      IdAppForm: 64,
      Id: 6400004,
      FieldName: "Amount",
      FieldType: "number",
      FieldTitle: "Amount",
      Position: 2,
      cssClasss: "col-12 ",
      HtmlType: "number",
      PlaceHolder: "",
      DefaultValue: "",
      OptionValues: "",
      DataSource: null,
      Required: true,
      Visible: true,
      ReadOnly: false,
      GroupBy: 0,
    },
  ]);
  const bindDataRemote = async () => { };
  const updateField = (fieldName, fieldValue) => {
    formik.setFieldValue(fieldName, fieldValue);

    if (fieldName === 'IdBillingService') {
      //Find the billing service selected
      let selectedBillingService = billingServices.find(service => service.Id === fieldValue * 1);
      console.log(selectedBillingService);

      if (selectedBillingService) {

        formik.setFieldValue('IdCurrency', selectedBillingService.IdCurrency);
        formik.setFieldValue('Amount', selectedBillingService.Price);

        let newFields = fields.map(field => {
          if (field.FieldName === 'IdCurrency' && !selectedBillingService.CurrencyChangeAllowed) {

            return {
              ...field,
              ReadOnly: true
            }
          } else if (field.FieldName === 'IdCurrency') {

            return {
              ...field,
              ReadOnly: false
            }
          }

          return field
        })

        setFields(newFields)

      }
    }
  };

  // const fillFormikObject = (record) => {
  //   if (fields && fields.length > 0) {
  //     fields.forEach((item) => {
  //       formik.setFieldValue(item.FieldName, record[item.FieldName]);
  //     });
  //   }

  //   //Now
  // };

  const prepareFormikObject = () => {
    let initialObject = {};
    let initialObjectValidation = {};

    if (fields) {
      fields.forEach((item) => {
        if (item.FieldName === "Id" || item.FieldName === "File") return;

        initialObject[item.FieldName] = item.value;

        if (item.Required) {
          initialObjectValidation[item.FieldName] = yupTypeValidator(item);
        }
      });
    }

    formik.initialValues = initialObject;

    setValidationSchema(yup.object(initialObjectValidation));
    //Now
  };

  const loadBillingServices = async () => {
    try {
      let query = `IdUser=${user.IdUser}&token=${user.Token}&Id=7f51e02cd7a8b31f2cc5eea5c1775fec4013da549ccb46dae33c226e76872c32`;
      const request = await API.getAction(`api/selector`, query);
      let results = request.data[0];
      let parsedResults = JSON.parse(results.JSONData)[0];
      console.log(parsedResults)
      if (parsedResults.Error) {
        console.error(parsedResults.Msg);
        return;
      }
      let recordResult = JSON.parse(parsedResults.JSONData);
      console.log(recordResult);
      setBillingServices(recordResult);
    } catch (error) {
      console.error(error);
    }
  }
  const handleSubmit = async (obj, event) => {
    console.log("object to save", obj);
    if (obj.Amount <= 0 || !obj.Amount) {
      setGeneralError("Amount must be greater than 0");
      toast({
        type: "error",
        message: "Amount must be greater than 0",
      });
      return;
    }

    try {
      setIsLoading(true);
      let query = `IdUser=${user.IdUser}&token=${user.Token}`;

      let queryData = {
        Data: `@Details=${obj.Details ? "'" + obj.Details + "'" : "null"
          }, @DetailReferences=${obj.DetailReferences ? "'" + obj.DetailReferences + "'" : "null"
          }, @IdBillingService=${obj.IdBillingService ? obj.IdBillingService : "null"
          }, @IdCurrency=${obj.IdCurrency ? obj.IdCurrency : "null"
          }, @Amount=${obj.Amount}, @GUIDReservationToFolio='${props.parent.GUIDReservationToFolio
          }'`,
      };
      // let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.postAction(
        `api/cashier/ApplyCharge?` + query,
        queryData ?? ""
      );

      if (request.status === 200) {
        let response = JSON.parse(request.data[0].JSONData)[0];
        if (response.Error) {
          setGeneralError(response.Msg);
          confirmAlert({
            message: `${response.Msg}`,
            buttons: [
              {
                label: "Ok",
                onClick: () => { },
              },
            ],
          });
          return;
        }
      }
      toast({
        type: "success",
        message: "Registro guardado correctamente",
      });

      props.toggle();
    } catch (error) {
      console.error(error);
      toast({
        type: "error",
        message: "An error occurred",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {},
    // enableReinitialize: true,
    validateOnChange: false,
    // validateOnBlur: false,
    validationSchema: validationsSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    prepareFormikObject();
    loadBillingServices();
    console.log(props)
  }, []);
  useEffect(() => {
    bindDataRemote();
  }, [props.selectedReservation]);
  // console.log(records)
  return (
    <Modal
      show={props.show}
      onHide={props.toggle}
      backdrop="static"
      keyboard={false}
      size={props.modalSize ?? "sm"}
    // className="modalRight"
    >
      <Modal.Header closeButton>
        <Modal.Title>Charge</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Container fluid className="overflow-auto table-responsive">
          <Row>
            {fields &&
              fields
                .filter(
                  (x) =>
                    x.FieldTitle !== "Audit Information" &&
                    x.FieldName !== "Id" &&
                    x.FieldName !== "IdCustomer" &&
                    x.FieldName !== "DateAdd" &&
                    x.FieldName !== "File" &&
                    x.FieldName !== "DateMod"
                )
                .map((item, index) => {
                  return (
                    <Col
                      className={
                        item.cssClasss + (!item.Visible ? " d-none" : "")
                      }
                      key={`col-${item.FieldName}-${index}`}
                    >
                      <label className="me-2 mt-2">
                        {item.FieldTitle}
                        {item.Required ? (
                          <i className="required-asterisk ms-1 text-danger">
                            *
                          </i>
                        ) : null}
                      </label>
                      <br />

                      <FieldSelector
                        actionMode={""}
                        model={item}
                        obj={formik.values}
                        key={`field-${item.FieldName}`}
                        updateField={updateField}
                        value={formik.values[item.FieldName]}
                      ></FieldSelector>
                      {formik.errors[item.FieldName] ? (
                        <div className="invalid text-sm my-1">
                          {formik.errors[item.FieldName]}
                        </div>
                      ) : null}
                    </Col>
                  );
                })}
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex gx-3 align-items-center justify-content-end">
          {Object.values(formik.errors).length > 0 && (
            <span className="invalid me-2">
              Please check the forms for errors
            </span>
          )}
          <button className="btn me-2" type="button" onClick={props.toggle} disabled={isLoading}>
            Close
          </button>
          <button
            className="btn btn-primary me-2"
            type="button"
            onClick={() => [formik.submitForm()]}
            disabled={isLoading}
          >
            Save
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ApplyCharge;
